import * as React from "react";
import websiteData = require("diy/util/websiteData");

interface HeaderIconProps {
    style?: React.CSSProperties;
}

export default class HeaderIcon extends React.Component<HeaderIconProps, {}> {
    render() {
        return (
            <div style={this.getStyle()}></div>
        );
    }

    private getStyle() {
        return Object.assign({}, this.props.style || {}, {
            display: "block",
            backgroundImage: "url(" + websiteData.getCdnUrl() + "/s/diy/site-admin/main/img/bar-sprite.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-730px -236px"
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/HeaderIcon.tsx
 **/